import Box from "@mui/material/Box";
import CircleIcon from "@mui/icons-material/Circle";

interface PropsType {
  data: any;
  flexDirection: string;
}

const ChartLegend = ({ data, flexDirection }: PropsType) => {
  return (
    <Box className={`pt-2 pb-2 d-flex flex-${flexDirection} flex-wrap`}>
      { 
        data.map((item) => (
          <Box key={item.text} className={"p-2 d-flex flex-row align-items-center"}>
            <CircleIcon
              sx={{
                mr: 1,
                color: item.color,
              }}
            />
            <p className="">{item.text}</p>
            { item.percentage !== undefined && <p className="m-0 ms-2">{item.percentage}%</p>}
          </Box>
        ))
      }
    </Box>
  );
};


export default ChartLegend;
